import { api } from '../../../lib/api'

export const UPDATE_REGISTER_USER_REQUEST = 'UPDATE_REGISTER_USER_REQUEST'
export const UPDATE_REGISTER_USER_SUCCESS = 'UPDATE_REGISTER_USER_SUCCESS'
export const UPDATE_REGISTER_USER_FAILED = 'UPDATE_REGISTER_USER_FAILED'
export const RESET_REGISTER_USER = 'RESET_REGISTER_USER'

export const updateRegisterContactInfo = function (data, isFormData = false, onComplete) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_REGISTER_USER_REQUEST
    })
    api.updateUser(data, isFormData).then(updatRegisterUserResponse => {
      dispatch({
        type: UPDATE_REGISTER_USER_SUCCESS,
        payload: updatRegisterUserResponse
      })
      if(onComplete) onComplete()
    }).catch(error => {
      dispatch({
        type: UPDATE_REGISTER_USER_FAILED,
        error
      })
    })
  }
}

export const resetRegisterContactInfo = function() {
  return function (dispatch) {
    dispatch({
      type: RESET_REGISTER_USER
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/register-flow/register-contact-info.js